export const profile = {
  name: "Arumugam N",
  title: "Python Full Stack Developer",
  subtitle: "& Machine Learning Engineer",
  tagline: "Building intelligent AI solutions, crafting scalable web applications, and developing innovative robotics projects with Python and Machine Learning.",
  location: "Tirunelveli, Tamil Nadu",
  email: "nmaru2904@gmail.com",
  phone: "+91 89031 48273",
  linkedin: "https://linkedin.com/in/arumugam-nallasivan",
  github: "https://github.com/blackwolf2902",
  resumePath: "/resume.pdf",
};

export const navItems = [
  { label: "About", id: "about" },
  { label: "Skills", id: "skills" },
  { label: "Tech Stack", id: "techstack" },
  { label: "Projects", id: "projects" },
  { label: "Experience", id: "experience" },
  { label: "Education", id: "education" },
  { label: "Achievements", id: "achievements" },
  { label: "GitHub", id: "github" },
  { label: "Contact", id: "contact" },
];